import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/privacy-policy/components/PrivacyPolicyContent.tsx");
